import OptimizerEditDto from './OptimizerEditDto';

export class BFGSOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.maxiter = null;
        /** @type {number} */
        this.gtol = null;
        /** @type {number} */
        this.norm = null;
        /** @type {number} */
        this.xrtol = null;
        /** @type {number} */
        this.c1 = null;
        /** @type {number} */
        this.c2 = null;
        /** @type {number} */
        this.eps = null;
    }

    /**
     * @typedef {Object} _BFGSOptimizerEditDtoProps
     * @property {number} maxiter
     * @property {number} gtol
     * @property {number} norm
     * @property {number} xrtol
     * @property {number} c1
     * @property {number} c2
     * @property {number} eps
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _BFGSOptimizerEditDtoProps} BFGSOptimizerEditDtoProps
     */
    /**
     * 
     * @param {BFGSOptimizerEditDtoProps} props
     * @returns {BFGSOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.maxiter = props.maxiter;
        this.gtol = props.gtol;
        this.norm = props.norm;
        this.xrtol = props.xrtol;
        this.c1 = props.c1;
        this.c2 = props.c2;
        this.eps = props.eps;
        return this;
    }
}

export default BFGSOptimizerEditDto;